import { Col, Row } from 'antd';
import React from 'react';

import { StepState } from '../utils';
import styles from './FeedPlayer.module.css';

const StepTitleCard: React.FC<{
  title: string;
  noTitle?: boolean;
  transcribeState?: StepState;
}> = ({ title, transcribeState }) => {
  const className =
    transcribeState === StepState.new
      ? styles.numberCircleGray
      : transcribeState === StepState.done
      ? styles.numberCircleGreen
      : styles.numberCircleSpin;
  return (
    <Row
      className={
        // 'flex-center-row justify-start-row align-top-row ' +
        styles.chapterHeader
      }
      // style={{
      //   fontFamily: 'Gotham Rnd SSm Light',
      //   fontSize: '12pt',
      //   padding: '15pt 16pt',
      //   alignItems: 'center',
      // }}
    >
      <div className={styles.chapterHeaderContent}>
        <Col span={2}>
          <div className={`${styles.chapterCircleIndicator} ${className}`} />
        </Col>
        <Col span={22}>
          <span className={styles.stepTitle}>{title}</span>
        </Col>
      </div>
    </Row>
  );
};

export default StepTitleCard;
